<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.bxx">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;font-family:宋体;">Cored-wire</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-size:12px;">CaSi Wire</span>
          <span style="font-size:12px;">:</span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-size:12px;">
            CA 30%MIN&nbsp; SI 50%MIN&nbsp; AL 2%MAX&nbsp;
            P 0.04%MAX&nbsp; C 1%MAX
          </span>
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-size:12px;">Size：</span>
          <span style="font-size:12px;">5-50MM&nbsp; 90%MIN</span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12px;font-family:宋体;">Diameter：</span>
        <span style="font-size:12px;font-family:宋体;">∮</span>
        <span style="font-size:12px;font-family:宋体;">13mm</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-size:12px;">Weight of wire：</span>
          <span style="font-size:12px;">390±10g/M</span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-size:12px;">Weight of alloy：</span>
          <span style="font-size:12px;">230±10g/M</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        bxx:require('../../../assets/img/common/bxx.jpg')
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/bxx.vue